import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=5389dc99&scoped=true&"
import script from "./translate.vue?vue&type=script&lang=ts&"
export * from "./translate.vue?vue&type=script&lang=ts&"
import style0 from "./translate.vue?vue&type=style&index=0&id=5389dc99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389dc99",
  null
  
)

export default component.exports